// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"cover-tooltip_tooltip__OtnpQ"};